import { Field } from "formik";
import { Form } from "react-bootstrap";
import { GroupTitle } from "../../../../StyledComponents";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { EntranceDateSubForm, Schema as EntranceDateSchema } from '../subforms/EntranceDate';
import { StudyOfLawSubForm, Schema as StudyOfLawSchema } from '../subforms/StudyOfLaw'
import { GrantsSubForm, Schema as GrantsSchema } from '../subforms/Grants'
import { NonAcademicCommitmentSubForm, Schema as NonAcademicCommitmentSchema } from '../subforms/NonAcademicCommitment';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { ApplicationForSubForm, Schema as ApplicationForSchema } from '../subforms/ApplicationFor';

export const JuristInitiativSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(DocumentsSchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(EntranceDateSchema)
        .concat(NameAndContactSchema(settings))
        .concat(StudyOfLawSchema(settings))
        .concat(GrantsSchema)
        .concat(NonAcademicCommitmentSchema(settings))
        .concat(ApplicationForSchema(settings))
);

export const JuristInitiativ = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <GroupTitle>Kontaktdaten</GroupTitle>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />

            <GroupTitle>Bewerbung für</GroupTitle>
            <Field component={ApplicationForSubForm} colors={colors} />

            <GroupTitle>Studium</GroupTitle>
            <Field component={StudyOfLawSubForm} colors={colors} settings={settings} />
            <Field component={GrantsSubForm} colors={colors} settings={settings} />
            <Field component={NonAcademicCommitmentSubForm} colors={colors} settings={settings} />

            <GroupTitle>Sonstiges</GroupTitle>
            <Field component={OtherInformationSubForm} colors={colors} />

            <GroupTitle>Dokumente</GroupTitle>
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}